/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
    this.preloadCrossSells();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.initCrossSells();
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.initCrossSells();
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);

    if (this.crossSellIdleCallbackId && window.cancelIdleCallback) {
      window.cancelIdleCallback(this.crossSellIdleCallbackId);
    } else if (this.crossSellPreloadTimeoutId) {
      clearTimeout(this.crossSellPreloadTimeoutId);
    }
  }

  preloadCrossSells() {
    const preload = () => {
      this.initCrossSells();
    };

    if (window.requestIdleCallback) {
      this.crossSellIdleCallbackId = window.requestIdleCallback(preload, { timeout: 1500 });
    } else {
      this.crossSellPreloadTimeoutId = setTimeout(preload, 600);
    }
  }

  initCrossSells() {
    const init = () => {
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => {
        if (typeof el.init === 'function') {
          el.init();
        }
      });
    };

    if (window.customElements && !customElements.get('cc-cart-cross-sell')) {
      customElements.whenDefined('cc-cart-cross-sell').then(init);
      return;
    }

    init();
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
